import { _ as _objectSpread2 } from './objectSpread2-c1340c1c.esm.js';
import { _ as _slicedToArray } from './slicedToArray-aa291011.esm.js';
import { DEFAULT_CONTENT_HOST, Internal } from '@valbuild/core';
import { VAL_CONFIG_RECEIVED_LISTENER, VAL_CONFIG_LISTENER } from '@valbuild/shared/internal';
import React from 'react';

var textEncoder = new TextEncoder();
/*
 * See the useRemoteConfigReceiver.tsx for the sender
 */
function useRemoteConfigSender(config) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    sentRemoteConfigHash = _React$useState2[0],
    setSentRemoteConfigHash = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    receivedRemoteConfigHash = _React$useState4[0],
    setReceivedRemoteConfigHash = _React$useState4[1];
  React.useEffect(function () {
    var sendConfig = function sendConfig() {
      var sharedConfig = _objectSpread2(_objectSpread2({}, config), {}, {
        // We're in NextJS now, so we can get process.env variables
        contentHostUrl: process.env.VAL_CONTENT_URL || DEFAULT_CONTENT_HOST
      });
      var hash = Internal.getSHA256Hash(textEncoder.encode(JSON.stringify(sharedConfig)));
      setSentRemoteConfigHash(hash);
      window.dispatchEvent(new CustomEvent(VAL_CONFIG_LISTENER, {
        detail: {
          type: "val-config",
          config: config,
          hash: hash
        }
      }));
    };
    if (sentRemoteConfigHash === null || sentRemoteConfigHash !== receivedRemoteConfigHash) {
      sendConfig();
      var interval = setInterval(function () {
        sendConfig();
      }, 1000);
      return function () {
        clearInterval(interval);
      };
    }
  }, [config, receivedRemoteConfigHash, sentRemoteConfigHash]);
  React.useEffect(function () {
    var configListener = function configListener(event) {
      if (!(event instanceof CustomEvent)) {
        console.warn("Received message of type val-config, but it was not a CustomEvent", event);
        return;
      }
      if (event.detail.type !== "val-config-received") {
        console.warn("Received message of type val-config, but it did not have the expected type", event.detail);
        return;
      }
      var hash = event.detail.hash;
      if (!hash) {
        console.warn("Received message of type val-config, but it did not have a hash", event.detail);
        return;
      }
      setReceivedRemoteConfigHash(hash);
    };
    window.addEventListener(VAL_CONFIG_RECEIVED_LISTENER, configListener);
    return function () {
      window.removeEventListener(VAL_CONFIG_RECEIVED_LISTENER, configListener);
    };
  }, [config]);
}

export { useRemoteConfigSender as u };
